export enum FormSpreeFormsEnum {
	Contact = 'https://formspree.io/f/xrbklglv',
}
